import type { MessageDescriptor } from '@cbhq/i18n';
import { defineMessages } from '@cbhq/i18n';

const messages = defineMessages({
  addMember: {
    id: 'Approvals.actions.addMember',
    defaultMessage: 'Add member',
    description: 'Approval action label for inviting/adding an organization member',
  },
  removeMember: {
    id: 'Approvals.actions.removeMember',
    defaultMessage: 'Remove member',
    description: 'Approval action label for removing an organization member',
  },
  changeMemberRole: {
    id: 'Approvals.actions.changeMemberRole',
    defaultMessage: 'Change member role',
    description: 'Approval action label for changing an organization member role',
  },
  cancelInvite: {
    id: 'Approvals.actions.cancelInvite',
    defaultMessage: 'Cancel invite',
    description: 'Approval action label for cancelling a member invitation',
  },
  manageApprovalRules: {
    id: 'Approvals.actions.manageApprovalRules',
    defaultMessage: 'Manage approval rules',
    description: 'Approval action label for managing approval rules',
  },
  unknown: {
    id: 'Approvals.actions.unknown',
    defaultMessage: 'Unknown action',
    description: 'Fallback approval action label when the action cannot be resolved',
  },
});

export type FormatActionLabel = (descriptor: MessageDescriptor) => string;

// Keyed by the backend's stable actionKey (PG-style identifier).
const ACTION_LABEL_MESSAGES: Record<string, MessageDescriptor> = {
  'member.create_invite': messages.addMember,
  'member.remove': messages.removeMember,
  'member.update_role': messages.changeMemberRole,
  'member.delete_invite': messages.cancelInvite,
  'approval_rule.manage': messages.manageApprovalRules,
};

export function getApprovalActionLabel(
  actionKey: string | undefined,
  formatMessage: FormatActionLabel,
): string {
  const message = actionKey ? ACTION_LABEL_MESSAGES[actionKey] : undefined;
  return formatMessage(message ?? messages.unknown);
}
